import { useEffect, useState } from "react";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import "./App.scss";
import {
  PlayerMode,
  selectPlayer,
  setPlayerMode,
} from "./features/player/playerSlice";
import {
  Localization,
  selectTheme,
  setMode,
  showLoginPopup,
  ThemeMode,
} from "./features/theme/themeSlice";
import { Helmet } from "react-helmet";
import { Views } from "./views";
import { useAppSelector } from "./app/hooks";
import { GetConfigQuery } from "./API";
import { getConfig } from "./graphql/queries";
import Amplify, { API, Auth } from "aws-amplify";
import { setConfig } from "./features/configapp";
import { HashRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import LockedLayout from "./layouts/LockedLayout";
import AppLocale from "./lang";

function App() {
  const theme = useAppSelector(selectTheme);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [kioskMode, setKioskMode] = useState(false);
  const player = useAppSelector(selectPlayer);
  const locale: Localization = theme.language as any;
  const currentAppLocale = AppLocale[locale];

  useEffect(() => {
    if (kioskMode ) {
      dispatch(setMode(ThemeMode.KIOSK));
      dispatch(setPlayerMode(PlayerMode.KIOSK));
    } else {
      dispatch(setMode(ThemeMode.DEFAULT));
      dispatch(setPlayerMode(PlayerMode.DEFAULT));
    }
  }, [kioskMode]);

  useEffect(() => {
    //navigate('/');
    (async () => {
      try {
        await Auth.currentAuthenticatedUser();
        const result: GraphQLResult<GetConfigQuery> = (await API.graphql({
          query: getConfig,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,

          variables: {},
        })) as GraphQLResult<GetConfigQuery>;
        if (result.data.getConfig)
          dispatch(setConfig(JSON.parse(result.data.getConfig)));
        console.log("RESULT CONFIG", result);
      } catch {
        const result: GraphQLResult<GetConfigQuery> = (await API.graphql({
          query: getConfig,
          authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
          variables: {},
        })) as GraphQLResult<GetConfigQuery>;
        if (result.data.getConfig)
          dispatch(setConfig(JSON.parse(result.data.getConfig)));
        console.log("RESULT CONFIG", result);
      }
    })();
    if (
      location.search === "?mode=kiosk" ||
      location.search === "?mode=kiosk&tk=3984jsdlkfoepgf"
    ) {
    //  navigate("/kiosk");
    }

    // console.log("props", location.search);
    const kiosk = localStorage.getItem("kiosk");
    //  console.log("kiosks", kiosk);
    if (kiosk !== null) {
      setKioskMode(true);
    }
  }, []);

  if (theme.showPinForm) {
    return (
      <IntlProvider locale={theme.language} messages={currentAppLocale}>
        <div id="main-wrapper" className="main-wrapper bg bg-sf4">
          <LockedLayout />
        </div>
      </IntlProvider>
    );
  }

  return kioskMode ? (
    <>
      <Helmet>
        <title>Kiosk PGP</title>
        <link rel="manifest" href="manifestkiosk.json" />
      </Helmet>
      <Views />
    </>
  ) : (
    <>
      <Helmet>
        <title>PGP Bet System</title>
        <link rel="manifest" href="manifest.json" />
      </Helmet>
      <Views />
    </>
  );
}

export default App;
